import { render, staticRenderFns } from "./editcurriculumType.vue?vue&type=template&id=31bd52b5&scoped=true&"
import script from "./editcurriculumType.vue?vue&type=script&lang=js&"
export * from "./editcurriculumType.vue?vue&type=script&lang=js&"
import style0 from "./editcurriculumType.vue?vue&type=style&index=0&id=31bd52b5&lang=scss&scoped=true&"
import style1 from "./editcurriculumType.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd52b5",
  null
  
)

export default component.exports